// permission.js —— 完整替换 beforeEach 即可
import router from './router'
import store from './store'
import { Message } from 'element-ui'

const whiteList = ['/login']; // 免登录白名单

// 取访问此路由链条的最大 minLevel（父子取最高要求）
function requiredLevelOf(to) {
  const levels = (to.matched || []).map(r => {
    const v = r.meta && typeof r.meta.minLevel === 'number' ? r.meta.minLevel : 0
    return v
  })
  return levels.length ? Math.max(...levels) : 0
}

router.beforeEach(async (to, from, next) => {
  const hasToken = store.getters.getToken
  if (!hasToken) {
    if (whiteList.includes(to.path)) return next()
    return next(`/login`)
  }

  // 已登录
  if (to.path === '/login') return next({ path: '/' })

  const userLevel = store.getters.getAdminLevel || 0
  const needLevel = requiredLevelOf(to)

  if (userLevel >= needLevel) {
    return next()
  } else {
    Message.error('无权限访问该页面')
    // 用 replace 避免形成“后退又进来”的死循环
    return next({ path: '/403', replace: true })
  }
})

router.afterEach(() => {})
